import Jt808AddParameterdataModal from './jt808-add-parameterdata-modal.vue'
export default Jt808AddParameterdataModal
